import React, { useState } from 'react';
import Styles from './SeguroAuto25PortalApp.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
function SeguroAuto25PortalApp() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="seguro-auto-portal-app">
        <ContainerHome24>
          <div className="portal-app-card portal-card">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 992 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/seguro-auto-25/portal-app/img-portal-segurado.webp"
                    />
                    <source
                      type="image/jpg"
                      srcSet="assets/seguro-auto-25/portal-app/img-portal-segurado.jpg"
                    />
                    <img
                      src="assets/seguro-auto-25/portal-app/img-portal-segurado.jpg"
                      alt="Mulher sentada no sofá usando celular, simbolizando praticidade na contratação de seguro de automóvel pelo app ou site da Santander Financiamentos."
                    />
                  </picture>
                )}
                {width > 992 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/seguro-auto-25/portal-app/img-portal-segurado-desk.webp"
                    />
                    <source
                      type="image/jpg"
                      srcSet="assets/seguro-auto-25/portal-app/img-portal-segurado-desk.jpg"
                    />
                    <img
                      src="assets/seguro-auto-25/portal-app/img-portal-segurado-desk.jpg"
                      alt="Mulher sentada no sofá usando celular, simbolizando praticidade na contratação de seguro de automóvel pelo app ou site da Santander Financiamentos."
                    />
                  </picture>
                )}
              </>
            )}
            <h3 className="portal-app-card-titulo">Portal do segurado</h3>
            <p className="portal-app-card-texto">
              Acesse o portal para consultar itens relacionados ao seu seguro
            </p>
            <a
              href="https://segurado.santanderauto.com.br/login?utm_source=santander-financiamentos&um_medium=LP"
              target="_blank"
              className="portal-app-card-link"
            >
              Saiba mais
            </a>
          </div>
          <div className="portal-app-card app-card">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 992 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/seguro-auto-25/portal-app/img-app-santander-auto.webp"
                    />
                    <source
                      type="image/jpg"
                      srcSet="assets/seguro-auto-25/portal-app/img-app-santander-auto.jpg"
                    />
                    <img
                      src="assets/seguro-auto-25/portal-app/img-app-santander-auto.jpg"
                      alt="Homem sorrindo e utilizando o celular, representando facilidade na contratação de seguro de automóvel pelo app da Santander Financiamentos."
                    />
                  </picture>
                )}
                {width > 992 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/seguro-auto-25/portal-app/img-app-santander-auto-desk.webp"
                    />
                    <source
                      type="image/jpg"
                      srcSet="assets/seguro-auto-25/portal-app/img-app-santander-auto-desk.jpg"
                    />
                    <img
                      src="assets/seguro-auto-25/portal-app/img-app-santander-auto-desk.jpg"
                      alt="Homem sorrindo e utilizando o celular, representando facilidade na contratação de seguro de automóvel pelo app da Santander Financiamentos."
                    />
                  </picture>
                )}
              </>
            )}
            <h3 className="portal-app-card-titulo">Aplicativo Santander Auto</h3>
            <p className="portal-app-card-texto">
              Baixe o App santander Auto para ter em sua mão todas as opções do seu seguro. É fácil,
              rápido e está sempre ao seu alcance.
            </p>
            <div className="portal-app-card-lojas">
              <a
                href="https://play.google.com/store/apps/details?id=com.auto.santander.segurado"
                target="_blank"
              >
                <img src="assets/seguro-auto-25/portal-app/img-google.svg" alt="" />
              </a>
              <a
                href="https://apps.apple.com/us/app/segurado-santander-auto/id1474847283?l=pt&ls=1"
                target="_blank"
              >
                <img src="assets/seguro-auto-25/portal-app/img-app-store.svg" alt="" />
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default SeguroAuto25PortalApp;
